import CategoryPage from "~/components/knowledge-base/CategoryPage"

export default CategoryPage
